// source: type/subscription_type.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.type.Subscription', null, global);
goog.exportSymbol('proto.type.SubscriptionStatus', null, global);
goog.exportSymbol('proto.type.SubscriptionType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.Subscription = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.Subscription, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.Subscription.displayName = 'proto.type.Subscription';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.Subscription.prototype.toObject = function(opt_includeInstance) {
  return proto.type.Subscription.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.Subscription} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.Subscription.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    subscriptionType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    startAt: (f = msg.getStartAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endAt: (f = msg.getEndAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    subscriptionStatus: jspb.Message.getFieldWithDefault(msg, 5, 0),
    orderId: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of Subscription as accepted by the `fromObject` method.
 * @record
 */
proto.type.Subscription.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.userId;

  /** @type {?|undefined} */
  this.subscriptionType;

  /** @type {?|undefined} */
  this.startAt;

  /** @type {?|undefined} */
  this.endAt;

  /** @type {?|undefined} */
  this.subscriptionStatus;

  /** @type {?|undefined} */
  this.orderId;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.Subscription.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.Subscription}
 */
proto.type.Subscription.fromObject = function(obj) {
  var msg = new proto.type.Subscription();
  obj.userId != null && jspb.Message.setField(msg, 1, obj.userId);
  obj.subscriptionType != null && jspb.Message.setField(msg, 2, obj.subscriptionType);
  obj.startAt && jspb.Message.setWrapperField(
      msg, 3, google_protobuf_timestamp_pb.Timestamp.fromObject(obj.startAt));
  obj.endAt && jspb.Message.setWrapperField(
      msg, 4, google_protobuf_timestamp_pb.Timestamp.fromObject(obj.endAt));
  obj.subscriptionStatus != null && jspb.Message.setField(msg, 5, obj.subscriptionStatus);
  obj.orderId != null && jspb.Message.setField(msg, 6, obj.orderId);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.Subscription}
 */
proto.type.Subscription.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.Subscription;
  return proto.type.Subscription.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.Subscription} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.Subscription}
 */
proto.type.Subscription.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {!proto.type.SubscriptionType} */ (reader.readEnum());
      msg.setSubscriptionType(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartAt(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndAt(value);
      break;
    case 5:
      var value = /** @type {!proto.type.SubscriptionStatus} */ (reader.readEnum());
      msg.setSubscriptionStatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.Subscription.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.Subscription.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.Subscription} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.Subscription.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getStartAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndAt();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSubscriptionStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.type.Subscription.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.Subscription} returns this
 */
proto.type.Subscription.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional SubscriptionType subscription_type = 2;
 * @return {!proto.type.SubscriptionType}
 */
proto.type.Subscription.prototype.getSubscriptionType = function() {
  return /** @type {!proto.type.SubscriptionType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.type.SubscriptionType} value
 * @return {!proto.type.Subscription} returns this
 */
proto.type.Subscription.prototype.setSubscriptionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp start_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.type.Subscription.prototype.getStartAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.type.Subscription} returns this
*/
proto.type.Subscription.prototype.setStartAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.Subscription} returns this
 */
proto.type.Subscription.prototype.clearStartAt = function() {
  return this.setStartAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.Subscription.prototype.hasStartAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp end_at = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.type.Subscription.prototype.getEndAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.type.Subscription} returns this
*/
proto.type.Subscription.prototype.setEndAt = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.Subscription} returns this
 */
proto.type.Subscription.prototype.clearEndAt = function() {
  return this.setEndAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.Subscription.prototype.hasEndAt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional SubscriptionStatus subscription_status = 5;
 * @return {!proto.type.SubscriptionStatus}
 */
proto.type.Subscription.prototype.getSubscriptionStatus = function() {
  return /** @type {!proto.type.SubscriptionStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.type.SubscriptionStatus} value
 * @return {!proto.type.Subscription} returns this
 */
proto.type.Subscription.prototype.setSubscriptionStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string order_id = 6;
 * @return {string}
 */
proto.type.Subscription.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.Subscription} returns this
 */
proto.type.Subscription.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * @enum {number}
 */
proto.type.SubscriptionType = {
  SUBSCRIPTION_TYPE_NONE: 0,
  SUBSCRIPTION_TYPE_LIFE_30: 1,
  SUBSCRIPTION_TYPE_LIFE_90: 2,
  SUBSCRIPTION_TYPE_LIFE_180: 3
};

/**
 * @enum {number}
 */
proto.type.SubscriptionStatus = {
  SUBSCRIPTION_STATUS_NONE: 0,
  SUBSCRIPTION_STATUS_WAITING_FOR_APPLIED: 1,
  SUBSCRIPTION_STATUS_APPLIED: 2,
  SUBSCRIPTION_STATUS_NOT_APPLICABLE: 3
};

goog.object.extend(exports, proto.type);
